export default {
  "app_name": import.meta.env.VITE_APP_SITE_NAME,
  "shopping_agent": "Agente de Compras",
  "forwarding": "Reenvío",
  "services": "Servicios",
  "about": "Sobre Nosotros",
  "expert_buy": "Compra Experta",
  "shipping_calculator": "Calculadora de Envío",
  "customer_review": "Opiniones de Clientes",
  "dropshipping": "Dropshipping",
  "business_service": "Servicio para Empresas",
  "trusted_seller": "Vendedores de Confianza",
  "blog": "Blog",
  "user_guides": "Guías de Usuario",
  "terms_of_service": "Términos de Servicio",
  "terms_of_shipping": "Términos de Envío",
  "privacy_policy": "Política de Privacidad",
  "faq": "Preguntas Frecuentes",
  "home": "Inicio",
  "notice": "Avisos",
  "cart": "Carrito",
  "me": "Mi Cuenta",
  "service_menu": "Menú de Servicios",
  "account": "Cuenta",
  "user_center": "Centro de Usuario",
  "my_order": "Mis Pedidos",
  "my_store": "Mi Tienda",
  "log_out": "Cerrar Sesión",
  "sign_in": "Iniciar Sesión",
  "sign_up": "Registrarse",
  "compensation_taxation": "Compensación e Impuestos",
  "tok_forum": "Foro",
  "get_community_help": "Únete a nuestro foro",
  "community_des": "Únete a nuestro foro para obtener ayuda y ayudar a otros",
  "page_home": {
    "title": "Tu Destino Definitivo",
    "description": "Agente de compras chino",
    "search_product_text": "URL del Producto",
    "timeline": [
      {
        "title": "Realiza el Pedido",
        "subtitle": "Selección y Compra"
      },
      {
        "title": "Envía los Paquetes",
        "subtitle": "Control de Calidad y Envío Internacional"
      },
      {
        "title": "Recepción",
        "subtitle": "Recibe y Comparte"
      }
    ],
    "cards": [
      ["¡Regístrate", "y obtén un cupón de $350!"],
      ["Guía", "para principiantes"],
      ["Únete a nosotros", "en Reddit y Discord"]
    ],
    "shop_chinese": {
      "title": "Compra en sitios de comercio electrónico chinos",
      "cards": [
        {
          "title": "Realiza tus pedidos",
          "description": "Disfruta de compras sin complicaciones para cualquier producto de China, disponible en línea o fuera de línea. Para realizar un pedido, simplemente pega el enlace del producto. Disfruta de nuestro servicio completo, desde la búsqueda hasta la compra, con total facilidad."
        },
        {
          "title": "Envío al almacén de NiuniuBox",
          "description": "Compra a diferentes vendedores a través de nuestro servicio, y agruparemos eficientemente tus compras. Todos los artículos se enviarán al almacén de NiuniuBox en China, simplificando el proceso para ti."
        },
        {
          "title": "Control de Calidad",
          "description": "Una vez que tus productos llegan al almacén de NiuniuBox, pasan por un riguroso control de calidad. Nuestro equipo verifica minuciosamente cada artículo para detectar cualquier defecto y garantizar la conformidad en tamaño, color, etc. Con NiuniuBox, ten la tranquilidad de contar con nuestro dedicado servicio postventa."
        },
        {
          "title": "Envío Internacional",
          "description": "Elige los productos de tu inventario en el almacén y agrúpalos fácilmente en un solo paquete. Con los fiables servicios de envío internacional de NiuniuBox, tus compras se entregan directamente en tu puerta. Disfruta de la comodidad de un servicio de envío de clase mundial."
        }
      ]
    },
    "bottom": [
      {
        "title": "Productos en Abundancia",
        "description": "Encontramos para ti productos variados y económicos de China"
      },
      {
        "title": "Costo Reducido",
        "description": "Un solo costo de envío para productos de diferentes vendedores, todos agrupados en un solo paquete"
      },
      {
        "title": "Servicio de Calidad",
        "description": "Valoramos tu lealtad y nuestro objetivo es ofrecer un servicio y soporte excepcionales"
      },
      {
        "title": "Respuesta Rápida",
        "description": "Respuesta garantizada a todas tus preguntas sobre nuestro servicio"
      }
    ],
    "migration": {
      "title": "Anuncio importante",
      "dear_users": "Estimados usuarios:",
      "announce_before_link": "Nos complace anunciar que Niuniubox ha pasado a llamarse oficialmente Pikobuy ",
      "link_label": "www.pikobuy.com",
      "closing": "Seguiremos brindándole nuestro servicio dedicado bajo nuestro nuevo nombre de marca.",
      "got_it": "Entendido"
    }
  },
  "page_shopping": {
    "shopping_des": "Comprar desde China",
    "shopping_step": "1.Encuentra y busca un producto 2.Paga los artículos 3.Compramos por ti 4.Paga el envío 5.Enviamos por ti",
    "category": "Categoría",
    "load_more_items": "Cargar más artículos",
    "note": "Aviso legal: Todos los productos disponibles para nuestro servicio de agente de compras que se muestran en nuestro sitio web provienen de plataformas de compras de terceros y no son vendidos directamente por nosotros. Por lo tanto, no somos responsables de ningún problema causado por la infracción de los derechos de propiedad intelectual o derechos de autor de la mercancía.",
    "bottom_text": "Como agente profesional de Taobao, te ayudamos a comprar numerosos productos a precios muy bajos en los sitios de compras más grandes de China. Somos tu agente de Taobao para encontrar, comprar, inspeccionar y entregar artículos de Taobao.com, 1688.com. Nuestro presupuesto incluye el abastecimiento en China, la compra y el envío internacional. Ofrecemos los mayores descuentos para envíos internacionales desde China a todos los países, incluyendo EE. UU., Canadá, Reino Unido, Australia, Francia, Singapur, México, Brasil, Chile, etc. Estés donde estés, entregamos los paquetes directamente en tu puerta. Proporcionamos información de seguimiento en línea para todos los envíos. Contamos con gerentes de servicio al cliente profesionales para ayudarte a comprar y enviar con éxito.",
    "process_data": "Procesar datos",
    "process_des": "Puedes saber todo sobre tu pedido. Siempre que te preocupes, tenemos datos para contártelo todo."
  },
  "meta": {
    "index_title": "Agente de Taobao | Agente de Tmall | Agente de 1688 | Taobao en inglés | Agente de Compras | Transitario de China",
    "index_des": "Somos una plataforma de agente de compras china. Ayudamos a los clientes a comprar productos en Taobao. Comprar tus artículos favoritos de China nunca ha sido tan conveniente y fácil.",
    "shopping_agent_title": "Agente de Compras",
    "shopping_agent_des": "Compra productos chinos con un agente de compras. Agente de Taobao, agente de 1688, agente de Weidian, agente de Yupoo.",
    "forwarding_title": "Agente de Carga - Envía tu paquete desde China",
    "forwarding_des": "Plataforma profesional de transbordo global, con almacenes de transbordo y que proporciona servicios de logística profesionales a Estados Unidos, Reino Unido, Canadá, Alemania, Australia, Singapur, México y otros países, envío a todo el mundo",
    "expert_buy_title": "Compra Experta",
    "expert_buy_des": "Compra productos a través de un agente de Taobao, importa desde China. Precios de envío más bajos. Sin cargos por servicio.",
    "calculator_title": "Estimación de costos de logística internacional",
    "calculator_des": "Te ayudamos a estimar los costos logísticos globales. Servicio de logística asequible. Servicio de logística más rápido.",
    "trusted_seller_title": "Vendedores de Confianza",
    "trusted_seller_des": "Vendedores de Confianza: Compra a estos vendedores, y nosotros te lo enviamos. Vendedores de Taobao, vendedores de Weidian."
  },
  "my_parcel": {
    "internationalParcels": "Paquetes Internacionales",
    "trackYourInternationalShipments": "Rastrea tus envíos internacionales y configura las preferencias de envío",
    "pleaseSelect": "Por favor, seleccione",
    "yourRemark": "Tu observación",
    "startDate": "Fecha de inicio",
    "endDate": "Fecha de finalización",
    "alertTrackParcels": "Rastrea tus paquetes aquí. Los paquetes con estado 'Listo para configurar envío' han sido embalados y medidos, y están listos para ser configurados para el envío.",
    "noPackagesToShip": "No tienes paquetes para enviar",
    "parcel": "Paquete",
    "parcelID": "ID del paquete:",
    "shippingLabel": "Gastos de envío:",
    "pending": "pendiente",
    "finalFee": "Tarifa final:",
    "discount": "Descuento:",
    "coupon": "Cupón:",
    "created": "Creado el:",
    "status": "Estado",
    "shippingMethod": "Método de envío",
    "notConfiguredYet": "Aún no configurado",
    "products": "producto(s)",
    "measured": "Medido",
    "estimated": "Estimado",
    "dimensions": "Dimensiones:",
    "weightInformation": "Información de peso",
    "billingWeight": "Peso facturable:",
    "na": "N/A",
    "actual": "Real:",
    "volume": "Volumen:",
    "action": "Acción",
    "configureShippingMethod": "Método de envío",
    "payShipping": "Pagar envío",
    "track": "Rastrear",
    "address": "Dirección",
    "shipping": "Envío:",
    "configure": "Configurar",
    "pay": "Pagar",
    "viewMoreProducts": "Ver más productos en este paquete",
    "orderID": "ID de pedido:",
    "quantity": "Cantidad:",
    "times": "x",
    "addressLabel": "Dirección",
    "yourRemarkTitle": "Tu observación",
    "parcelRemarkTitle": "Observación del paquete",
    "noRemarks": "No hay observaciones para este paquete",
    "parcelImages": "Imágenes del paquete",
    "failedToLoad": "Error al cargar",
    "noImages": "No hay imágenes disponibles para este paquete",
    "productsInParcel": "Productos en el paquete",
    "type": "Tipo:",
    "noProducts": "No hay detalles de productos disponibles para este paquete",
    "configureShipping": "Configurar envío",
    "alertPackagePrepared": "Tu paquete ha sido preparado. Ahora selecciona tu método de envío y proporciona tu dirección de entrega.",
    "packageDetails": "Detalles del paquete",
    "readyForShipping": "Listo para envío",
    "actualWeight": "Peso real:",
    "actualDimensions": "Dimensiones reales:",
    "packagingNotes": "Notas de embalaje:",
    "step1SubmitAddress": "Paso 1: Enviar dirección",
    "select": "Seleccionar",
    "recipientName": "Nombre del destinatario",
    "email": "Correo electrónico",
    "phoneNumber": "Número de teléfono",
    "country": "País",
    "city": "Ciudad",
    "stateProvince": "Estado/Provincia",
    "zipCode": "Código postal",
    "selectShippingMethod": "Seleccionar método de envío",
    "selectCountryFirst": "Primero selecciona el país",
    "selectedShippingMethod": "Método de envío seleccionado",
    "estimatedDelivery": "Tiempo de entrega estimado",
    "estimatedFee": "Tarifa estimada:",
    "changeShippingMethod": "Cambiar método de envío",
    "remark": "Observación",
    "shippingRemarkPlaceholder": "CPF / CNPJ / ID fiscal / observación de envío",
    "saveAddress": "Guardar dirección",
    "saveAddressHint": "Guarda esta dirección en tu libreta para uso futuro",
    "submitShippingConfiguration": "Enviar configuración de envío",
    "parcelDetailsTitle": "Detalles del paquete",
    "statusSection": "Estado",
    "actions": "Acciones",
    "parcelDetails": "Detalles del paquete",
    "trackingInfo": "Información de seguimiento",
    "addressInfo": "Información de dirección",
    "costDetails": "Detalles de costos",
    "costPending": "pendiente",
    "shippingMethodNotConfigured": "Método de envío no configurado",
    "packageDimensions": "Dimensiones del paquete",
    "measuredDimensions": "Dimensiones medidas",
    "estimatedDimensions": "Dimensiones estimadas",
    "length": "Largo:",
    "width": "Ancho:",
    "height": "Alto:",
    "totalVolume": "Volumen total:",
    "volumetricWeight": "Peso volumétrico:",
    "weightCalculation": "Cálculo de peso",
    "weightCalcVolumeUsed": "Peso volumétrico utilizado (el mayor)",
    "weightCalcActualUsed": "Peso real utilizado (el mayor)",
    "billingWeightTooltip": "Este es el peso utilizado para la facturación (el mayor entre el real y el volumétrico)",
    "remarks": "Observaciones",
    "delivery_number": "ID del paquete"
  },
  "footer": {
    "supportTitle": "Soporte",
    "support": ["Sobre Nosotros", "Contáctanos", "Tarifas de Servicio", "Gastos de Envío"],
    "servicesTitle": "Servicios",
    "services": ["Compras en Taobao", "Agente de Yupoo", "Agente de Weidian", "Abastecimiento de Productos"],
    "tutorialTitle": "Tutorial",
    "tutorial": ["Guía de Compras", "Nuestro Blog", "Gastos de Envío"],
    "resourcesTitle": "Recursos",
    "resources": ["Política de Envío", "Reembolsos y Devoluciones", "Política de Privacidad", "Términos de Servicio"],
    "followTitle": "Síguenos",
    "follow": ["Youtube", "TikTok", "Facebook", "Quora", "Twitter"],
    "copyright": "© 2025 NiuNiuBox - Hong Kong Niuniubox Technology Co., Limited",
    "paymentMethods": ["PayPal", "American Express", "Discover", "JCB", "Mastercard", "VISA"]
  },
  "sidebar_titles": ["PERFIL DE USUARIO", "PEDIDOS Y ENVÍO", "FINANZAS", "CUENTA"],
  "sidebar": ["Cuenta", "Pedido", "Almacén", "Ensayo", "Paquete", "Direcciones", "Cancelar", "Historial", "Saldo", "Mensajes", "Cupón", "Configuración", "Afiliación"],
  "page_order_history": {
    "title": "Historial de Pedidos",
    "search": {
      "order_number_placeholder": "Número de Pedido",
      "product_name_placeholder": "Nombre del Producto",
      "remark_placeholder": "Observación",
      "style_sku_placeholder": "Estilo/SKU",
      "start_date_placeholder": "Fecha de Inicio",
      "end_date_placeholder": "Fecha de Fin",
      "status_placeholder": "Por favor, seleccione"
    },
    "buttons": {
      "search": "Buscar",
      "pay_shopping_orders": "Pagar Pedidos de Compra",
      "pay_order": "Pagar Pedido",
      "view_order": "Ver Pedido",
      "item_photos": "Fotos del Artículo",
      "view_product": "Ver Producto"
    },
    "table": {
      "empty_text": "Aún no tienes ningún pedido.",
      "header": {
        "image": "Imagen",
        "details": "Detalles",
        "product": "Producto",
        "action": "Acción"
      },
      "body": {
        "order": "Pedido:",
        "total": "Total:",
        "type": "Tipo:",
        "status": "Estado:",
        "time": "Fecha:",
        "style": "Estilo:",
        "quantity": "Cantidad:",
        "remark": "Observación:",
        "name": "Nombre:"
      }
    },
    "qc_dialog": {
      "title": "Fotos de Control de Calidad",
      "notice": "A partir de agosto, ya no ofreceremos el servicio de fotos de CC.",
      "empty_description": "Tu artículo aún no ha llegado a nuestro almacén."
    }
  },
  "navbar": {
    "items": ["Estimación de Envío", "Afiliación", "Contacto", "Guía"],
    "cart": "Carrito",
    "login": "Iniciar Sesión",
    "register": "Registrarse",
    "logout": "Cerrar Sesión",
    "no": "No",
    "logout_confirm": "¿Estás seguro de que quieres cerrar sesión?",
    "search": "Buscar",
    "searchPlaceholder": "URL del producto",
    "dropdown": ["Centro de Usuario", "Mensaje", "Pedido", "En Almacén", "Mis Ensayos", "Mis Paquetes", "Cancelar Pedido", "Cerrar Sesión"],
    "me": "Yo",
    "home": "Inicio",
    "menu": "Menú",
    "notice": "Avisos"
  },
  "page_my_order": {
    "product_pic": "Foto del Producto",
    "product_qc": "Foto de Control de Calidad",
    "store_order_no": "Número de Pedido de la Tienda",
    "type": "Tipo",
    "details": "Ver",
    "remark": "Observación",
    "process": "Procesando",
    "cn_track": "Seguimiento en CN",
    "pay_order": "Pagar Pedido",
    "search": "Buscar"
  },
  "page_calculator": {
    "des": "Calcular el precio de envío mundial",
    "item_category": "Categoría del Producto",
    "product_weight": "Peso",
    "product_length": "Largo",
    "product_width": "Ancho",
    "product_height": "Alto",
    "check": "Verificar Ahora",
    "cost_note": "Nota: el peso del paquete no debe ser inferior a 2.5 KG para UPS/DHL/FedEx. De lo contrario, solo se puede enviar por la Línea de Paquetes Pequeños",
    "about_service": "Nuestra calculadora de envío es una función complementaria que ofrecemos en nuestro sitio web como parte de nuestros servicios de agente de compras y mensajería internacional. Al usar nuestra calculadora de envío, puedes estimar los costos de envío aproximados a pagar según las dimensiones de tus productos o paquetes y tu país de destino. También puedes usar nuestra calculadora para verificar las diferentes empresas de transporte disponibles para tu país de destino, así como sus tiempos de envío estimados.",
    "service_title": "Acerca de la Calculadora",
    "common_goods": "Mercancías Comunes",
    "brand_goods": "Productos de Marca",
    "liquid_goods": "Productos Líquidos",
    "battery_goods": "Productos con Baterías",
    "shipping_method": "Método de Envío",
    "delivery_time": "Tiempo de Entrega",
    "warehouse": "Almacén",
    "estimated_cost": "Costo Estimado",
    "method": "Método"
  },
  "page_message": {
    "title": "Mensaje",
    "des": "Debes prestar atención a esta parte de las noticias, porque te enviaremos un mensaje o un correo electrónico."
  },
  "page_cart": {
    "title": "Mi Carrito",
    "item": "Artículo",
    "product": "Producto",
    "price": "Precio",
    "quantity": "Cantidad",
    "freight": "Flete",
    "total": "Total",
    "info": "Información",
    "operate": "Operar",
    "pay_now": "Pagar Ahora",
    "confirm_buy": "¿Confirmar la compra?",
    "yes": "Sí",
    "no": "No"
  },
  "page_settlement": {
    "title": "Confirma tu pedido",
    "information": "Nota",
    "note_line1": "1. Toma fotos del producto gratis",
    "note_line2": "2. El monto del pago incluye el costo de los bienes, la tarifa de procesamiento de pagos y la tarifa de servicio",
    "note_line3": "3. Te informaremos sobre el progreso del pedido por correo electrónico. Por favor, revísalo a tiempo",
    "note_line4": "4. Cuando tus paquetes lleguen al almacén, deberás pagar los gastos de envío",
    "note_line5": "5. Debes pagar una tarifa adicional por cada pago (PayPal)"
  },
  "page_shopping_payment": {
    "title": "Primer pago de los productos",
    "des": "Nota: esta página solo puede pagar los productos. Los gastos de envío se pagan en la página #Paquetes Internacionales#.",
    "total": "Total",
    "order_no": "Pedido",
    "pay_now": "Ir a Pagar",
    "shopping_notice": "Aviso Importante:"
  },
  "page_person": {
    "account": "Cuenta",
    "user_center": "Centro de Usuario",
    "wallet": "Billetera",
    "orders": "Pedidos",
    "my_order": "Mi Pedido",
    "my_warehouse": "En Almacén",
    "my_parcel": "Paquetes Internacionales",
    "address_book": "Libreta de Direcciones",
    "online_store": "Tienda en Línea",
    "my_store": "Mi Tienda",
    "activity": "Actividad",
    "invite": "Invitar",
    "coupons": "Cupones"
  },
  "page_seller": {
    "title": "Vendedor de Confianza",
    "buy_hanfu_title": "Compra Hanfu chino de estos vendedores, y luego enviamos tu paquete",
    "buy_sneaker_title": "Compra zapatillas de estos vendedores, y luego enviamos tu paquete",
    "buy_cosplay_title": "Compra productos de cosplay de estos vendedores, y luego enviamos tu paquete",
    "step_line1": "1. Encuentra productos de estos vendedores",
    "step_line2": "2. Envía la orden de compra",
    "step_line3": "3. Te lo enviamos"
  },
  "page_profile": {
    "account": "Cuenta",
    "email": "Correo Electrónico",
    "balance": "Saldo"
  },
  "page_wallet": {
    "top_up": "Recargar",
    "underpaid": "Pago Insuficiente",
    "balance_details": "Detalles del Saldo",
    "time": "Hora",
    "empty": "Sin Registros",
    "amount": "Monto",
    "status": "Estado",
    "info": "Información",
    "pay": "Pagar",
    "paid": "Pagado",
    "confirm": "Confirmar",
    "discount_info": "Información de Descuento",
    "and_get": "y obtén",
    "get_extra": "extra"
  },
  "in_warehouse": {
    "packages_in_warehouse": "Paquetes en el almacén",
    "product_name": "Nombre del producto",
    "please_select": "Por favor, seleccione",
    "remark": "Observación",
    "style_sku": "Estilo/SKU",
    "start_date": "Fecha de inicio",
    "end_date": "Fecha de finalización",
    "reset_selections": "Restablecer selecciones",
    "select_products_alert": "Selecciona los productos para empacar juntos. Una vez empacados, serás notificado y podrás elegir las opciones de envío en la página 'Mis Paquetes'.",
    "estimated_weight": "Peso estimado: {weight} KG",
    "rehearse_parcel": "Ensayo de paquete",
    "request_packaging": "Solicitar embalaje",
    "orders_not_arrived_alert": "Tienes {count} pedidos que aún no han llegado al almacén. Por favor, confirma si deseas empacar ahora o esperar a todos los artículos.",
    "table_empty_text": "Nada en esta página. Puedes consultar otras páginas.",
    "column_image": "Imagen",
    "column_details": "Detalles",
    "order_label": "Pedido:",
    "total_label": "Total:",
    "type_label": "Tipo:",
    "status_label": "Estado:",
    "time_label": "Hora:",
    "style_label": "Estilo:",
    "quantity_prefix": "x",
    "no_remark": "Sin observación",
    "package_info_label": "Información del paquete",
    "weight_label": "Peso:",
    "length_label": "Largo:",
    "width_label": "Ancho:",
    "height_label": "Alto:",
    "unit_kg": "KG",
    "unit_cm": "CM",
    "action_label": "Acción",
    "view": "Ver",
    "photos": "Fotos",
    "cancel": "Cancelar",
    "mobile_label_total": "Total:",
    "mobile_label_type": "Tipo:",
    "mobile_label_name": "Nombre:",
    "view_product": "Ver producto",
    "mobile_style_label": "Estilo:",
    "no_items_selected": "No se han seleccionado artículos",
    "submit_packaging_request": "Enviar solicitud de embalaje",
    "dialog_request_packaging_title": "Solicitud de Embalaje",
    "dialog_request_packaging_info": "Empacaremos tus artículos seleccionados juntos. Una vez empacados, podrás ver las dimensiones reales y elegir las opciones de envío en 'Mis Paquetes'.",
    "packaging_instructions": "Instrucciones de embalaje",
    "placeholder_packaging_instructions": "¿Instrucciones especiales de embalaje o alguna preocupación?",
    "selected_items": "Artículos seleccionados",
    "packaging_note": "Nota: Después de empacar, determinaremos las dimensiones y el peso exactos de tu paquete. Luego podrás elegir tu método de envío y proporcionar tu dirección en la sección 'Mis Paquetes'.",
    "new_packaging_process": "Nuevo Proceso de Embalaje",
    "step_request_packaging": "Solicitar Embalaje:",
    "step_request_packaging_desc": "Selecciona productos y envía la solicitud de embalaje.",
    "step_warehouse_packaging": "Embalaje en Almacén:",
    "step_warehouse_packaging_desc": "Nuestro personal empacará tus artículos seleccionados.",
    "step_measurement": "Medición:",
    "step_measurement_desc": "Mediremos las dimensiones y el peso exactos de tu paquete.",
    "step_notification": "Notificación:",
    "step_notification_desc": "Se te notificará cuando tu paquete esté listo.",
    "step_shipping_setup": "Configuración de Envío:",
    "step_shipping_setup_desc": "Ve a 'Mis Paquetes' para seleccionar las opciones de envío e ingresar tu dirección.",
    "step_make_payment": "Realizar Pago:",
    "step_make_payment_desc": "Paga el envío según las dimensiones y el peso reales del paquete.",
    "confirm_packaging_title": "Confirmar Solicitud de Embalaje",
    "confirm_packaging_text": "Estás a punto de solicitar el embalaje de {count} artículo(s). ¿Continuar?",
    "item_qc_photos": "Fotos de CC del Artículo",
    "empty_qc_desc": "Tu artículo aún no ha llegado a nuestro almacén.",
    "return_items_title": "Devolver Artículos",
    "return_items_text": "Devolver artículos puede incurrir en costos adicionales. ¿Aún deseas continuar?",
    "number_of_items_to_return": "Número de artículos a devolver:",
    "confirm": "Confirmar"
  },
  "page_address_book": {
    "title": "Mi Libreta de Direcciones",
    "buttons": {
      "add_new": "Añadir Nuevo",
      "save": "Guardar Dirección"
    },
    "dialog": {
      "title": "Añade Tu Dirección",
      "alert": "¡Añade tu dirección y podrá ser usada la próxima vez!",
      "form": {
        "contact_name": "Nombre de Contacto",
        "address": "Dirección",
        "city": "Ciudad",
        "province": "Estado/Provincia",
        "country": "País",
        "country_placeholder": "Seleccionar País de Destino",
        "zip_code": "Código Postal",
        "phone": "Teléfono",
        "email": "Correo Electrónico",
        "email_placeholder": "Recomendado"
      }
    }
  },
  "page_wallet": {
    "header": {
      "title": "Resumen de la Billetera",
      "subtitle": "Gestiona tu saldo y tu historial de transacciones"
    },
    "balance_card": {
      "label": "Saldo Disponible",
      "currency": "USD",
      "top_up_button": "Recargar Saldo"
    },
    "history": {
      "title": "Historial de Transacciones",
      "count": "{count} transacciones",
      "empty": {
        "title": "Aún no hay transacciones",
        "subtitle": "Tu historial de transacciones aparecerá aquí"
      },
      "item": {
        "order_prefix": "Pedido:",
        "balance_after_prefix": "Saldo:",
        "note_prefix": "Nota:",
        "complete_payment_button": "Completar Pago",
        "mobile": {
          "order_id_label": "ID del Pedido:",
          "balance_after_label": "Saldo Posterior:",
          "status_label": "Estado:"
        }
      }
    },
    "top_up_dialog": {
      "title": "Recargar",
      "form": {
        "amount_label": "Ingresar Monto (USD)",
        "quick_select_title": "Selección Rápida de Monto",
        "create_payment_button": "Crear Pago"
      }
    }
  },
  "page_message_center": {
    "title": "Centro de Mensajes",
    "filters": {
      "all": "Todos",
      "unread": "No leídos",
      "read": "Leídos",
      "search_placeholder": "Buscar mensajes..."
    },
    "actions": {
      "mark_all_read": "Marcar todos como leídos",
      "delete_all": "Eliminar todos los mensajes",
      "refresh": "Actualizar Mensajes"
    },
    "delete_confirm": {
      "title": "¿Eliminar este mensaje?",
      "confirm_button": "Eliminar",
      "cancel_button": "Cancelar"
    },
    "empty_states": {
      "no_search_results": "No se encontraron mensajes que coincidan con tu búsqueda.",
      "no_unread": "No tienes mensajes no leídos.",
      "no_read": "No tienes mensajes leídos.",
      "no_messages_yet": "Tu centro de mensajes está vacío."
    }
  },
  "page_user_profile": {
    "tabs": {
      "profile": "Perfil",
      "account_safety": "Seguridad de la Cuenta"
    },
    "profile_section": {
      "email": "Correo Electrónico:",
      "gender": "Género:",
      "country": "País:",
      "language": "Idioma:",
      "current_language": "Inglés",
      "phone": "Teléfono:",
      "birthday": "Fecha de Nacimiento:",
      "vip_prefix": "VIP",
      "max_vip_level": "VIP5",
      "privilege_title": "Mis Privilegios",
      "privilege_table_header": "Privilegio de Nivel"
    },
    "safety_section": {
      "modify_password_title": "Modificar Contraseña",
      "modify_password_desc": "Una contraseña de mayor nivel hace que tu cuenta sea más segura. Se recomienda cambiar tu contraseña regularmente incluyendo números y letras.",
      "modify_password_button": "Modificar Contraseña"
    },
    "update_info_dialog": {
      "title": "Actualizar Información de la Cuenta",
      "account_name_label": "Nombre de la Cuenta",
      "phone_label": "Número de Teléfono",
      "gender_label": "Género",
      "gender_placeholder": "Seleccionar",
      "country_label": "País",
      "country_placeholder": "Seleccionar país",
      "birthday_label": "Fecha de Nacimiento",
      "birthday_placeholder": "Seleccionar",
      "save_button": "Guardar Información"
    },
    "update_password_dialog": {
      "title": "Actualizar Contraseña",
      "old_password_label": "Contraseña Antigua",
      "new_password_label": "Nueva Contraseña",
      "confirm_password_label": "Confirmar Contraseña",
      "save_button": "Guardar"
    }
  },
  "page_shipping_calculator": {
    "hero": {
      "title": "Tu Agente de Compras Chino Definitivo"
    },
    "form_card": {
      "title": "Estimación de Gastos de Envío",
      "subtitle": "Ingresa los detalles de tu paquete a continuación para obtener los costos de envío precisos",
      "country_label": "País de Destino",
      "country_placeholder": "Seleccionar País",
      "country_search_placeholder": "Buscar un país...",
      "no_countries_for_letter": "No hay países que comiencen con {letter}.",
      "no_countries_for_search": "No se encontraron países para \"{query}\".",
      "category_label": "Categoría del Producto",
      "category_placeholder": "Seleccionar Categoría",
      "select_main_category_first": "Primero selecciona una categoría principal.",
      "weight_label": "Peso (kg)",
      "length_label": "Largo (cm)",
      "width_label": "Ancho (cm)",
      "height_label": "Alto (cm)",
      "required_label": "Requerido",
      "optional_label": "(Opcional)",
      "optional_placeholder": "Opcional",
      "calculating_button": "Calculando...",
      "submit_button": "Obtener Gastos de Envío"
    },
    "summary": {
      "title": "Resumen de la Consulta de Envío",
      "sort_by": "Ordenar por:",
      "sort_price": "Precio",
      "sort_time": "Tiempo de Tránsito",
      "destination": "Destino:",
      "weight": "Peso:",
      "dimensions": "Dimensiones:",
      "volume": "Volumen:",
      "categories": "Categorías:"
    },
    "results": {
      "loading_text": "Calculando opciones de envío disponibles...",
      "no_options_title": "No Hay Opciones de Envío Disponibles",
      "no_options_desc": "No se encontraron opciones de envío válidas para los detalles ingresados y el destino. <br /> Por favor, revisa las restricciones de peso, dimensiones y categoría de producto para el país seleccionado.",
      "initial_state_text": "Por favor, ingresa los parámetros requeridos (País, Peso) y haz clic en \"Obtener Gastos de Envío\".",
      "all_unavailable_info": "Todos los canales de envío para esta combinación no están disponibles. Ver detalles a continuación.",
      "est_transit_time": "Tiempo de Tránsito Est.",
      "volume_weight": "Peso Volumétrico",
      "billing_weight": "Peso Facturable",
      "view_details_button": "Ver Detalles",
      "load_more_button": "Cargar más ({count} restantes)",
      "unavailable_channels_title": "Canales de Envío No Disponibles ({count})",
      "not_available_badge": "No Disponible",
      "reason_prefix": "Razón:"
    },
    "details_modal": {
      "overview_title": "Resumen del Envío",
      "shipping_fee": "Gastos de Envío",
      "description_title": "Descripción del Servicio",
      "no_description": "No hay descripción disponible.",
      "restrictions_title": "Restricciones de Transporte",
      "category_restrictions_title": "Restricciones de Categoría de Producto",
      "legend_can_send": "Se Puede Enviar",
      "legend_cannot_send": "No se Puede Enviar",
      "can_send_subheading": "Se Puede Enviar:",
      "cannot_send_subheading": "No se Puede Enviar:",
      "no_allowed_items": "No se listan artículos permitidos específicos (se asume que los bienes generales están bien a menos que estén restringidos)",
      "no_prohibited_items": "No se listan artículos prohibidos específicos (se aplican las prohibiciones estándar del transportista)",
      "rules_title": "Reglas de Transporte",
      "weight_restriction_title": "Restricción de Peso",
      "dimension_restriction_title": "Restricción de Dimensión",
      "billing_rules_title": "Reglas de Facturación",
      "tax_info_title": "Información de Impuestos",
      "additional_fees_title": "Cargos Adicionales",
      "no_additional_fees": "No especificado (pueden aplicarse tarifas estándar del transportista)",
      "min_label": "Mín:",
      "max_label": "Máx:",
      "carrier_limit": "Límite del Transportista",
      "close_button": "Cerrar"
    }
  },
  "page_shopping_guide": {
    "header": {
      "title": "Guía de Compras",
      "description": "Guía para Comprar en Taobao, 1688, Weidian y Yupoo para Principiantes",
      "video_title": "Video del Proceso de Compra"
    },
    "process": {
      "title": "Proceso de Compra",
      "step1": {
        "title": "Paso 1: Seleccionar Producto",
        "description": "Encuentra el producto que quieres en Taobao.com, 1688.com, Tmall.com o Weidian."
      },
      "step2": {
        "title": "Paso 2: Buscar Producto",
        "description": "Si no puedes encontrar el producto que deseas, no dudes en pedir ayuda a nuestro servicio de atención al cliente 24/7. Copia y pega el enlace del producto en el sitio de NiuNiuBox. Si estás usando la aplicación de Taobao, también puedes encontrar el enlace del producto en la Página de Detalles del Producto de Taobao."
      },
      "step3": {
        "title": "Paso 3: Seleccionar Talla/Color",
        "description": "Confirma la talla y el color del producto que necesitas en NiuNiuBox, luego añádelo a tu carrito de compras."
      },
      "step4": {
        "title": "Paso 4: Primer Pago",
        "description": "Ve tu carrito de compras y completa el primer pago de los artículos seleccionados."
      },
      "step5": {
        "title": "Paso 5: Enviar Tu Dirección",
        "description": "Una vez que hayas completado el primer pago, el equipo de NiuNiuBox comprará los productos por ti. Después de que todos tus productos lleguen a nuestro almacén, deberás enviar tu dirección para que podamos empacar tus artículos en una caja grande."
      },
      "step6": {
        "title": "Paso 6: Segundo Pago",
        "description": "Después de que hayamos empacado tus productos, recibirás un correo electrónico con el peso del paquete y el costo de envío. Luego deberás pagar el costo de envío internacional, y enviaremos tu paquete desde nuestro almacén en China a tu dirección."
      },
      "step7": {
        "title": "Paso 7: Esperando Tu Paquete",
        "description": "Después de que tu paquete haya sido enviado, recibirás un número de seguimiento en 3 días. Esto te permitirá ver la ubicación de tu paquete."
      }
    }
  },
  "page_contact_us": {
    "title": "Contáctanos",
    "support_email_label": "Correo Electrónico de Soporte al Cliente:"
  },
  "page_my_account": {
    "title": "Mi Cuenta",
    "profile_card": {
      "member_type": "Miembro Ordinario",
      "member_since": "Miembro desde",
      "logout_confirm": "¿Estás seguro de que quieres cerrar sesión?",
      "top_up_button": "Recargar",
      "orders_label": "Pedidos",
      "coupons_label": "Cupones"
    },
    "balance_info": {
      "title": "Sobre Tu Saldo",
      "description": "Cuando solicitas cancelar un pedido, tus fondos restantes se transferirán automáticamente a tu saldo.",
      "highlight1": "Continúa comprando con tu saldo",
      "highlight2": "Contacta al servicio de atención al cliente para reembolsos a tu cuenta de pago"
    },
    "quick_actions": {
      "title": "Acciones Rápidas",
      "shopping_orders": "Pedidos de Compra",
      "in_warehouse": "En Almacén",
      "my_rehearsal": "Mi Ensayo",
      "my_parcels": "Mis Paquetes",
      "my_balance": "Mi Saldo",
      "messages": "Mensajes",
      "my_coupons": "Mis Cupones",
      "cancel_order": "Cancelar Pedido"
    },
    "recent_orders": {
      "title": "Pedidos Recientes",
      "view_all_button": "Ver Todos",
      "header_product": "Producto",
      "header_amount": "Monto",
      "header_date": "Fecha",
      "header_status": "Estado",
      "header_actions": "Acciones",
      "quantity_prefix": "Cant:",
      "details_button": "Detalles"
    },
    "invitation": {
      "title": "Invitar Amigos",
      "description": "Comparte nuestro sitio con amigos y gana recompensas:",
      "copy_button": "Copiar"
    }
  },
  "page_shopping_order": {
    "title": "Pedido de Compra",
    "search": {
      "order_number_placeholder": "Número de Pedido",
      "product_name_placeholder": "Nombre del Producto",
      "status_placeholder": "Por favor, seleccione",
      "remark_placeholder": "Observación",
      "style_sku_placeholder": "Estilo/SKU",
      "start_date_placeholder": "Fecha de Inicio",
      "end_date_placeholder": "Fecha de Fin",
      "search_button": "Buscar",
      "pay_button": "Pagar Pedidos de Compra"
    },
    "info_alert": "Esta página muestra pedidos de compra como los de Taobao/1688/Weidian. Por favor, selecciona los pedidos [Pendientes de Pago] y paga.",
    "table": {
      "empty_text": "Aún no tienes ningún pedido de compra",
      "header": {
        "image": "Imagen",
        "details": "Detalles",
        "product": "Producto",
        "action": "Acción"
      },
      "body": {
        "order_prefix": "Pedido:",
        "total_prefix": "Total:",
        "type_prefix": "Tipo:",
        "status_prefix": "Estado:",
        "time_prefix": "Hora:",
        "style_prefix": "Estilo:",
        "quantity_prefix": "Cantidad:",
        "remark_prefix": "Observación:",
        "name_prefix": "Nombre:"
      },
      "actions": {
        "pay_order": "Pagar Pedido",
        "view_order": "Ver Pedido",
        "item_photos": "Fotos del Artículo",
        "cancel_item": "Cancelar Artículo",
        "view_product": "Ver Producto"
      }
    },
    "qc_dialog": {
      "title": "Fotos de CC del Artículo",
      "empty_text": "Tu artículo aún no ha llegado a nuestro almacén."
    },
    "return_dialog": {
      "title": "Devolver Artículos",
      "confirmation_text": "Devolver artículos puede incurrir en costos adicionales. ¿Aún deseas continuar?",
      "quantity_label": "Número de artículos a devolver:",
      "cancel_button": "Cancelar",
      "confirm_button": "Confirmar"
    },
    "cancel_dialog": {
      "title": "Cancelar Pedido",
      "confirmation_text": "Si deseas cancelar este pedido, deberás pagar los gastos de envío. La tarifa se deducirá de tu pago ya realizado. ¿Deseas continuar?",
      "cancel_button": "Cancelar",
      "confirm_button": "Confirmar"
    }
  },
  "page_shipping_config": {
    "title": "Configuración de Envío",
    "summary": {
      "destination": "Destino:",
      "actual_weight": "Peso Real del Paquete:",
      "est_dimensions": "Dimensiones Estimadas:",
      "weight_note": "*El peso estimado del paquete se basa en el peso del producto, y el peso real se determinará después de pesarlo.",
      "product_types": "Tipos de Producto",
      "selected_method": "Método de Envío Seleccionado:",
      "selected_method_none": "Ninguno",
      "est_fee": "Tarifa Estimada:"
    },
    "status": {
      "loading": "Calculando opciones de envío disponibles...",
      "no_options": "No hay opciones de envío disponibles para el peso, dimensiones, tipos de producto y país actuales. <br />Por favor, revisa las restricciones."
    },
    "options": {
      "select_sr_label": "Seleccionar {channelName}",
      "shipping_fee": "Gastos de Envío",
      "volume_weight": "Peso Volumétrico",
      "volume_weight_formula": "Peso Volumétrico (KG) = L*A*H (CM) / {denominator}",
      "billing_weight": "Peso Facturable",
      "billing_weight_details": "Basado en el mayor entre el peso real ({weight} kg) y el peso volumétrico. Pueden aplicarse redondeos y mínimos según las reglas del canal.",
      "transit_time": "Tiempo de Tránsito",
      "hide_details_button": "Ocultar Detalles",
      "show_details_button": "Mostrar Detalles"
    },
    "details": {
      "category_restrictions_title": "Restricciones de Categoría de Producto",
      "legend_can_send": "Se Puede Enviar",
      "legend_cannot_send": "No se Puede Enviar",
      "can_send_subheading": "Se Puede Enviar:",
      "no_allowed_items": "No se listan artículos permitidos específicos (se asume que los bienes generales están bien a menos que estén restringidos)",
      "cannot_send_subheading": "No se Puede Enviar:",
      "no_prohibited_items": "No se listan artículos prohibidos específicos (se aplican las prohibiciones estándar del transportista)",
      "rules_title": "Reglas de Transporte",
      "weight_restriction_title": "Restricción de Peso",
      "min_label": "Mín:",
      "max_label": "Máx:",
      "carrier_limit": "Límite del Transportista",
      "dimension_restriction_title": "Restricción de Dimensión",
      "billing_rules_title": "Reglas de Facturación",
      "tax_info_title": "Información de Impuestos",
      "additional_fees_title": "Cargos Adicionales",
      "no_additional_fees": "No especificado (pueden aplicarse tarifas estándar del transportista)"
    },
    "confirm_button": "Confirmar"
  },
  "page_parcel_details": {
    "loading": "Cargando detalles del paquete...",
    "overview": {
      "title": "Resumen del Paquete",
      "parcel_id": "ID del Paquete",
      "payment_time": "Fecha de Pago",
      "status": "Estado",
      "shipping_cost": "Costo de Envío",
      "billing_weight": "Peso Facturable",
      "parcel_remark": "Observación del Paquete",
      "your_note": "Tu Nota"
    },
    "tracking": {
      "title": "Información de Seguimiento",
      "empty_text": "Aún no hay información de seguimiento. Recibirás un número de seguimiento una vez que se envíe (~3 días)."
    },
    "items": {
      "title": "Artículos del Producto",
      "empty_text": "No se encontraron artículos",
      "header_order_image": "Pedido / Imagen",
      "header_product_details": "Detalles del Producto",
      "header_qc_photos": "Fotos de CC",
      "order_prefix": "Pedido:",
      "sku_prefix": "SKU:",
      "quantity_prefix": "Cant:",
      "note_prefix": "Nota:"
    }
  },
  "page_affiliate": {
    "header": {
      "title": "Aumento de Bono del 30%",
      "description": "Basado en el Bono del Envío de Nuevas Afiliaciones"
    },
    "commission": {
      "title": "Mi Comisión de Promoción",
      "invited_users": "Usuarios Invitados:",
      "new_affiliates": "Nuevos Afiliados:",
      "active_users": "Usuarios Activos:"
    },
    "balance": {
      "title": "Mi saldo de afiliado",
      "amount_withdrawn": "Monto Retirado:",
      "withdrawn_button": "Retirar",
      "withdrawable_title": "Retirable",
      "board_earnings_title": "Ganancias por Creación de Tableros",
      "claim_button": "Reclamar"
    },
    "steps": {
      "step1": "Comparte códigos de invitación con tus amigos",
      "step2": "Un amigo realizó un pedido y recibió el paquete",
      "step3": "Obtén la comisión"
    },
    "promotion_method": {
      "title": "Método de Promoción",
      "mobile_description": "Descripción de la Regla Descripción de la Regla Descripción de la Regla",
      "desktop_description": "La comisión que recibes cada mes se transferirá directamente a tu cuenta personal.",
      "invite_link_label": "Enlace de Invitación:",
      "copy_link_button": "Copiar Enlace",
      "copy_code_button": "Copiar Código de Invitación",
      "download_qr_button": "Descargar Código QR"
    }
  },
  "page_product_details": {
    "promo_banner": "Compre productos rentables de sitios web de comercio electrónico chinos y ahorre más dinero. Envío mundial desde China.",
    "stats": {
      "sales": "Ventas:",
      "inventory": "Inventario:"
    },
    "info": {
      "original_link": "Enlace Original",
      "processing_time": "Después del pago, compraremos por usted dentro de las 12 horas.",
      "domestic_shipping": "Envío Nacional",
      "free_shipping": "Envío Gratis",
      "shipping_note": "El costo de envío local desde el vendedor a nuestro almacén en China."
    },
    "options": {
      "quantity": "Cantidad",
      "items_available": "{count} artículos disponibles",
      "order_remark": "Observación del Pedido:",
      "order_remark_subtitle": "Añada cualquier instrucción o solicitud especial",
      "remark_placeholder": "Por favor, deje un mensaje al vendedor, como color, talla, etc."
    },
    "actions": {
      "shipping_cost_estimate": "Estimación del Costo de Envío",
      "disclaimer_title": "Descargo de responsabilidad",
      "disclaimer_text": "Todos los productos disponibles para el servicio de agente de compras que se muestran en Niuniubox provienen de plataformas de compras de terceros y no son vendidos directamente por Niuniubox. Por lo tanto, Niuniubox no asume ninguna responsabilidad legal por problemas causados por la infracción de derechos de propiedad intelectual y derechos de autor de las mercancías.",
      "agreement_checkbox": "He leído y acepto",
      "buy_now": "Comprar Ahora",
      "add_to_cart": "Añadir al Carrito",
      "share": "Compartir"
    },
    "share_dialog": {
      "title": "Compartir este producto",
      "platform_facebook": "Facebook",
      "platform_whatsapp": "WhatsApp",
      "platform_wechat": "WeChat",
      "platform_discord": "Discord",
      "platform_email": "Correo electrónico",
      "copy_button": "Copiar"
    },
    "sidebar": {
      "original_site": "Sitio original:",
      "why_title": "¿Por qué Taobao, 1688, Weidian, Yupoo, Tmall?",
      "why_description": "Los productos en estas plataformas son muy baratos. Si necesita gastar la menor cantidad de dinero para comprar productos de alta calidad, comprar en estas plataformas es lo más rentable. Ofrecemos servicios de logística global por línea aérea y marítima.",
      "details_title": "Detalles del Producto",
      "empty_details": "Detalle del Producto Vacío."
    },
    "loading": {
      "try_again": "Intentar de Nuevo",
      "note_title": "Nota:",
      "error_note_1": "1. Puede contactarnos si no puede ver la información del producto.",
      "error_note_2": "2. El producto está agotado o la URL del producto no es válida. Por favor, verifique el enlace de su producto.",
      "error_note_3": "3. Plataformas compatibles: Taobao.com, 1688.com, Tmall.com, Weidian.com (Solo admite URL de producto)"
    }
  },
   "page_product_details": {
    "promo_banner": "Compre productos rentables de sitios web de comercio electrónico chinos y ahorre más dinero. Envío mundial desde China.",
    "stats": {
      "sales": "Ventas:",
      "inventory": "Inventario:"
    },
    "info": {
      "original_link": "Enlace Original",
      "processing_time": "Después del pago, compraremos por usted dentro de las 12 horas.",
      "domestic_shipping": "Envío Nacional",
      "free_shipping": "Envío Gratis",
      "shipping_note": "El costo de envío local desde el vendedor a nuestro almacén en China."
    },
    "options": {
      "quantity": "Cantidad",
      "items_available": "{count} artículos disponibles",
      "order_remark": "Observación del Pedido:",
      "order_remark_subtitle": "Añada cualquier instrucción o solicitud especial",
      "remark_placeholder": "Por favor, deje un mensaje al vendedor, como color, talla, etc."
    },
    "actions": {
      "shipping_cost_estimate": "Estimación del Costo de Envío",
      "disclaimer_title": "Descargo de responsabilidad",
      "disclaimer_text": "Todos los productos disponibles para el servicio de agente de compras que se muestran en Niuniubox provienen de plataformas de compras de terceros y no son vendidos directamente por Niuniubox. Por lo tanto, Niuniubox no asume ninguna responsabilidad legal por problemas causados por la infracción de derechos de propiedad intelectual y derechos de autor de las mercancías.",
      "agreement_checkbox": "He leído y acepto",
      "buy_now": "Comprar Ahora",
      "add_to_cart": "Añadir al Carrito",
      "share": "Compartir"
    },
    "share_dialog": {
      "title": "Compartir este producto",
      "platform_facebook": "Facebook",
      "platform_whatsapp": "WhatsApp",
      "platform_wechat": "WeChat",
      "platform_discord": "Discord",
      "platform_email": "Correo electrónico",
      "copy_button": "Copiar"
    },
    "sidebar": {
      "original_site": "Sitio original:",
      "why_title": "¿Por qué Taobao, 1688, Weidian, Yupoo, Tmall?",
      "why_description": "Los productos en estas plataformas son muy baratos. Si necesita gastar la menor cantidad de dinero para comprar productos de alta calidad, comprar en estas plataformas es lo más rentable. Ofrecemos servicios de logística global por línea aérea y marítima.",
      "details_title": "Detalles del Producto",
      "empty_details": "Detalle del Producto Vacío."
    },
    "loading": {
      "try_again": "Intentar de Nuevo",
      "note_title": "Nota:",
      "error_note_1": "1. Puede contactarnos si no puede ver la información del producto.",
      "error_note_2": "2. El producto está agotado o la URL del producto no es válida. Por favor, verifique el enlace de su producto.",
      "error_note_3": "3. Plataformas compatibles: Taobao.com, 1688.com, Tmall.com, Weidian.com (Solo admite URL de producto)"
    }
  },
  "shopping_steps": {
    "title": "Cómo Funciona",
    "steps_data": [
      {
        "title": "Encontrar Productos",
        "des": "Navega por millones de productos de mercados chinos como Taobao, 1688, Weidian, Tmall a precios de mayorista"
      },
      {
        "title": "Añadir al Carrito",
        "des": "Selecciona tus artículos, elige especificaciones y añádelos a tu carrito para una fácil gestión de pedidos"
      },
      {
        "title": "Realizar el Pago",
        "des": "Paga de forma segura por tus artículos, y nosotros los compraremos a diferentes vendedores en tu nombre"
      },
      {
        "title": "Recibir la Entrega",
        "des": "Enviamos tu paquete consolidado desde China hasta tu puerta con información de seguimiento completa"
      }
    ]
  }
}